export default __webpack_public_path__ + "static/maintenance-0fa95bc56d961208737941f82c5bf0cb.svg";